
import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";

const ChartRangeToggleGroup = ({ value, changeHandler, options }) => {
    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={changeHandler}
        >

            {
                options.map((option, idx) => {
                    return (
                        <ToggleButton key={idx} value={option.value} sx={{ padding: { xs: 1, md: 1.25 } }}>
                            <Typography fontSize={{ xs: "0.75em", md: "0.9em", lg: "1em" }}>{option.label}</Typography>
                        </ToggleButton>
                    );
                })
            }
        </ToggleButtonGroup>
    );
};

export default ChartRangeToggleGroup;